import { Divider } from 'antd'
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import React, { useEffect, useState } from 'react'

import { Doughnut } from 'react-chartjs-2'
import styled from 'styled-components'
ChartJS.register(ArcElement, Tooltip, Legend)

const ChartContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 20px;
  .chart-labels {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .chart-divider {
    width: 2px;
    height: 12px;
    background-color: #ccc;
  }
`
const LegendContainer = styled.div`
  width: 17rem;
  display: flex;
`
const LineHeight = styled.div`
  line-height: 2rem;
`
const LineHeightLegend = styled.div`
  line-height: 1.5rem;
`
const LineHeightLegendChart = styled.div`
  line-height: 1.7rem;
`
const StaticData = styled.div`
  width: 15rem;
  color: #999fac;
  font-weight: 600 !important;
  margin-top: 3rem;
  margin-left: 3rem;
`
const DynamicData = styled.div`
  width: 2rem;
  color: #343e59;
  font-weight: 600 !important;
  margin-top: 3rem;
  margin-left: 1rem;
`
const CustomDoughnut = styled(Doughnut)`
  .chartjs-render-monitor
    .chartjs-size-monitor
    .chartjs-render-monitor
    .chartjs-size-monitor-text {
    font-size: 18px;
  }

  .chartjs-render-monitor
    .chartjs-size-monitor
    .chartjs-render-monitor
    .chartjs-size-monitor-legend {
    font-size: 12px;
  }

  .chartjs-render-monitor
    .chartjs-size-monitor
    .chartjs-render-monitor
    .chartjs-size-monitor-legend
    .chartjs-legend-0
    span {
    color: #343e59;
  }
`

const DoughtChart = ({ roleViewChartData }) => {
  const [chartstatus, setChartstatus] = useState([])
  const [chartCount, setChartCount] = useState([])
  const [chartCounting, setChartCounting] = useState([])
  const [dashboard] = useState(React.createRef())
  const [pluginCreation, setPluginCreation] = useState(0)
  const isValidData = roleViewChartData?.totalExpCandidate?.length > 0
  const validChartCounting = isValidData ? chartCounting : [1]
  const validChartStatus = isValidData ? chartstatus : [emptyColor]
  const plugins = [
    {
      afterDraw: function (chart) {
        const width = chart.width,
          height = chart.height,
          ctx = chart.ctx
        ctx.font = 'bolder 20px Plus Jakarta Sans'
        ctx.fillStyle = '#343E59'
        ctx.textAlign = 'center'
        let check = 2.1
        if (chart._active?.length === 0) {
          ctx.font = 'bolder 16px arial'
          ctx.fillStyle = '#343E59'
          ctx.textAlign = 'center'
          ctx.fillText('Total Cand.', width / check, height / 2)
          ctx.fillText(pluginCreation, width / check, height / 1.7)
          ctx.save()
        }

        if (chart._active?.length > 0) {
          ctx.font = 'bolder 14px arial'
          ctx.fillStyle = '#343E59'
          ctx.textAlign = 'center'
          ctx.fillText('Total Cand.', width / check, height / 2)
          ctx.fillText(pluginCreation, width / check, height / 1.7)
          ctx.save()
        }
      },
    },
  ]
  const StaticLegend = [
    'Active Candidates',
    'On hold Candidates',
    'Rejected Candidates',
    'Offers Released',
    'Drive Scheduled',
  ]
  const backgroundColor = [
    '#5DB594',
    '#F3A66E',
    '#E35E50',
    '#3249D7',
    '#F7E501',
  ]

  function mapColors(data, colors) {
    return data?.map(item => {
      if (item === 'ACTIVE') {
        return colors[0]
      } else if (item === 'SHORTLISTED') {
        return colors[0]
      } else if (item === 'HOLD') {
        return colors[1]
      } else if (item === 'REJECTED') {
        return colors[2]
      } else if (item === 'SELECTED') {
        return colors[3]
      } else if (item === 'SCHEDULED') {
        return colors[4]
      }
    })
  }
  function getCounts(data, mapping) {
    const COUNT = mapping?.map(item => {
      const matchingData = data?.find(d => d?.status === item)
      return matchingData ? matchingData?.count : 0
    })

    return COUNT
  }

  useEffect(() => {
    let status = []
    let BETA = []
    let Count = []
    let driveCount = []
    status = roleViewChartData?.totalExpCandidate?.map(item => item?.status)
    driveCount = roleViewChartData?.totalExpCandidate?.map(item => item?.count)
    setChartCounting(driveCount)
    const dataMapping = [
      'SHORTLISTED',
      'HOLD',
      'REJECTED',
      'SELECTED',
      'SCHEDULED',
    ]
    BETA = mapColors(status, backgroundColor)
    Count = getCounts(roleViewChartData?.totalExpCandidate, dataMapping)
    setChartstatus(BETA)
    setChartCount(Count)
    setPluginCreation(roleViewChartData?.totalExpCandidateCount)
  }, [roleViewChartData, roleViewChartData?.totalExpCandidate])
  const LegendDot = styled.span`
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 5px;
    background-color: ${props => props.color};
  `
  const createLegendItem = (item, index) => {
    const color = backgroundColor[index % backgroundColor?.length]

    return (
      <li
        key={item}
        style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}
      >
        <LegendDot color={color} />
        <LineHeightLegend>{item}</LineHeightLegend>
      </li>
    )
  }

  const isEmptyData = roleViewChartData?.totalExpCandidate?.length == 0
  const emptyColor = 'lightgray'

  const data = {
    datasets: [
      {
        data: validChartCounting,
        borderWidth: 0,
        borderRadius: 5,
        borderColor: '#CCCFD6',
        cutout: '70%',
        backgroundColor: validChartStatus,
        hoverBackgroundColor: validChartStatus,
      },
    ],
  }

  const updateDimensions = () => {}
  useEffect(() => {
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])
  return (
    <>
      <ChartContainer>
        <CustomDoughnut
          key={(data, pluginCreation)}
          ref={dashboard}
          data={
            isEmptyData
              ? { datasets: [{ data: [1], backgroundColor: [emptyColor] }] }
              : data
          }
          width={200}
          height={200}
          plugins={plugins}
          options={{
            plugins: {
              legend: {
                display: false,
              },

              tooltip: {
                display: !isEmptyData,
                enabled: !isEmptyData,
              },
              datalabels: {
                display: false,
              },
            },

            maintainAspectRatio: false,
          }}
        />
      </ChartContainer>
      <LegendContainer>
        <StaticData>
          <LineHeight>Total Candidates</LineHeight>
          <Divider
            style={{ marginTop: '1em', width: '105%', marginBottom: '0.5rem' }}
          />

          <ul style={{ listStyle: 'none', padding: 0 }}>
            {StaticLegend?.map((item, index) => createLegendItem(item, index))}
          </ul>
        </StaticData>

        <DynamicData>
          <LineHeight>{roleViewChartData?.totalExpCandidateCount}</LineHeight>
          <Divider style={{ marginTop: '1em', marginBottom: '0.5rem' }} />
          {chartCount?.map((item, index) => (
            <LineHeightLegendChart key={index + item}>
              {item}
            </LineHeightLegendChart>
          ))}
        </DynamicData>
      </LegendContainer>
    </>
  )
}

export default DoughtChart
